var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8C9EA7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.683 2.734c0-.613.404-1.061.922-1.061h3.79c.518 0 .922.448.922 1.06v1.163H10V2.734c0-1.06-.71-1.87-1.605-1.87h-3.79C3.71.864 3 1.674 3 2.734v1.162h.683V2.734zM2.403 19.057h8.194c.79 0 1.403-.687 1.403-1.543V6.928H1v10.586c0 .856.613 1.543 1.403 1.543zM8.71 8.566c0-.19.155-.343.346-.343.191 0 .347.153.347.343v8.1c0 .19-.156.343-.347.343a.345.345 0 0 1-.346-.343v-8.1zm-2.555 0c0-.19.155-.343.346-.343.191 0 .346.153.346.343v8.1c0 .19-.155.343-.346.343a.345.345 0 0 1-.346-.343v-8.1zm-2.556 0c0-.19.156-.343.347-.343.191 0 .346.153.346.343v8.1c0 .19-.155.343-.346.343a.345.345 0 0 1-.347-.343v-8.1zM.838 5.918h11.324c.463 0 .838-.453.838-1.011 0-.558-.375-1.01-.838-1.01H.838c-.463 0-.838.452-.838 1.01s.375 1.01.838 1.01z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bin.3db9697e.svg";
export { ForwardRef as ReactComponent };